<button class="rs-input-icon-wrapper" tabindex="-1" mat-icon-button>
  <mat-icon
    *ngIf="isClearIcon"
    class="rs-input-icon"
    [svgIcon]="clearBold"
  ></mat-icon>
</button>
